import { Box, Container, Typography } from "@mui/material";

import { PCR } from "components/acronyms";
import { Subtitle1Text } from "components/shared/Typography";

export const TopBanner = () => (
  <Box
    component="section"
    position="relative"
    paddingTop={{ xs: "45px", sm: 3, md: 4 }}
    paddingBottom={{ xs: "53.45px", sm: 5, md: 7 }}
    className="default-bg"
    overflow="hidden"
  >
    <Container>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        gap={{ xs: "16px", sm: "24px", md: "30px" }}
        position="relative"
      >
        <Typography variant="h1" align="center">
          <Box
            fontSize={{ xs: 22, sm: 64 }}
            lineHeight={{ xs: "28px", sm: "80px" }}
            letterSpacing={{ xs: 0.25, sm: 0 }}
          >
            Anchored Multiplex <PCR /> (AMP<sup>™</sup>) technology platform
          </Box>
        </Typography>
        <Subtitle1Text align="center">
          Simply decoding cancer&apos;s complexity
        </Subtitle1Text>
      </Box>
    </Container>
  </Box>
);
